import { clsx } from '../functions.ts'
import { ReactNode } from 'react';
import './modal-close.css'
import { inputOnKeyUp } from "../functions.ts";

export function ModalClose(props:{style?: React.CSSProperties, label: string, disabled?: boolean, onClick: ()=>void}){
  return <button
  aria-label={props.label}
  inert={props.disabled}
  style={props.style} 
  className={clsx("modal-close", props.disabled && "button--disabled")} 
  onClick={()=>{props.onClick()}}
  onKeyUp={(event)=>inputOnKeyUp(event, props.onClick)}
  > <div role="presentation" aria-hidden className="x-bars">
          <div className="x-bar"></div>
          <div className="x-bar"></div>
        </div>
  </button>
}